<template>
  <v-dialog
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
    @keydown.esc="$emit('update:opened', false)"
    persistent
  >
    <v-card flat>
      <v-card-title class="title pb-0">
        {{ $t('confirmation') }}
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="
            documentsStillNeeded.length > 0 &&
              isEmpty(currentQuestionnaireOtherDocuments)
          "
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left"
        >
          You still have {{ documentsStillNeeded.length }} incomplete item{{
            documentsStillNeeded.length > 1 ? 's' : ''
          }}. We'll send you reminders to complete the remaining item{{
            documentsStillNeeded.length > 1 ? 's' : ''
          }}. No changes can be made to the submitted answers. If you have
          additional items to provide, {{ contactUsWording }}
        </v-alert>
        <v-alert
          v-else-if="
            documentsStillNeeded.length > 0 &&
              isEmpty(currentQuestionnaireOtherDocuments)
          "
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left"
        >
          You marked <b>Answer Later</b> or <b>Upload Later</b> to
          {{ documentsStillNeeded.length }} item{{
            documentsStillNeeded.length > 1 ? 's' : ''
          }}. We'll send you reminders to complete the remaining item{{
            documentsStillNeeded.length > 1 ? 's' : ''
          }}. No changes can be made to the submitted answers. If you have
          additional items to provide, {{ contactUsWording }}
        </v-alert>
        <v-alert
          v-else
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left"
        >
          No changes can be made after submitting. If you have additional items
          to provide, {{ contactUsWording }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          class="default-input primary text-capitalize"
          @click="$emit('confirm')"
        >
          {{ $t('confirm') }}
        </v-btn>
        <v-btn
          block
          outline
          class="default-input error--text text-capitalize"
          @click="$emit('update:opened', false)"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { mapGetters } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    submissionAgreed: {
      type: Boolean,
    },

    questionnaire: {
      type: Object,
      default: null,
    },

    currentQuestionnaire: {
      type: Object,
      default: null,
    },

    currentQuestionnaireOtherDocuments: {
      type: Array,
      default: null,
    },

    documentsStillNeeded: {
      type: Array,
    },
  },

  data() {
    return {};
  },

  methods: {
    isEmpty,
    get,
  },
  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),
    contactUsWording() {
      if (get(this.currentFirm, 'preferences.communication_disabled', false)) {
        return 'please contact us.';
      } else {
        return 'please message us using the chat icon on the top right.';
      }
    },
  },
};
</script>
